import React, { useCallback, useMemo, useRef } from 'react';
import type { BrandFilterViewModel } from 'autogen/swagger/all';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { ActiveCount } from '../shared/styles';

export default function BrandFilterMenuOpener({
    model: {
        displayName,
        brands,
        isActive,
        attribute: { id }
    },
    ...restProps
}: {
    model: BrandFilterViewModel;
}) {
    const activeOptions = useMemo(() => brands.options.filter((option) => option.isSelected).length, [brands.options]);
    const filterMenuId = id.toString();
    const { openFilterMenu } = useFilterMenu(filterMenuId);

    // Prefetch brand menu chunk on first user intent (hover/focus/pointer) – no effect on SRR until interaction
    const prefetchedRef = useRef(false);
    const prefetch = useCallback(() => {
        if (prefetchedRef.current) return;
        prefetchedRef.current = true;

        // Fire and forget dynamic import (same chunk key as lazy() in FilterMenu.tsx)
        import('./BrandFilterMenu').catch(() => {
            // swallow error – prefetch failure shouldn't block interaction
        });
    }, []);

    return (
        <ButtonWithActiveState
            size="lg"
            isActive={isActive}
            onClick={openFilterMenu}
            onMouseEnter={prefetch}
            onFocus={prefetch}
            onPointerDown={prefetch}
            {...restProps}
        >
            {displayName} {!!activeOptions && <ActiveCount>{activeOptions}</ActiveCount>}
        </ButtonWithActiveState>
    );
}
